import { addLocalDays, startOfLocalDay } from '../../../../Utils/dates/localDay';

/** The last 28 local days including today: [local midnight 27 days ago, local midnight tomorrow). */
export const lastFourWeeks = now => ({
    from: addLocalDays(startOfLocalDay(now), -27),
    to: addLocalDays(startOfLocalDay(now), 1)
});
